import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';
import './ExchMatchOddsTable.scss';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from '@material-ui/core';
import { toast } from 'react-toastify';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import { IonIcon } from '@ionic/react';
import moment from 'moment';

// import Modal from '@material-ui/core/Modal';
import { BsData, PlaceBetRequest } from '../../models/BsData';
import ExchOddBtn from '../ExchOddButton/ExchOddButton';
import { UserBet } from '../../models/UserBet';
import InfoImg from '../../assets/images/sportsbook/info.svg';
import TimerImg from '../../assets/images/sportsbook/delay.svg';
import CricketLiveImg from '../../assets/images/sportsbook/cricket-live.svg';
import TennisLiveImg from '../../assets/images/sportsbook/tennis-live.svg';
import FootballLiveImg from '../../assets/images/sportsbook/soccer-live.svg';
import { SelectedObj } from '../../models/ExchangeSportsState';
import { EventDTO } from '../../models/common/EventDTO';
import {
  MatchOddsDTO,
  MatchOddsRunnerDTO,
} from '../../models/common/MatchOddsDTO';
import MarketTermsCondi from '../../components/MarketTermsCondi/MarketTermsCondi';
import Modal from '../../components/Modal/Modal';
import {
  getAllMarketsByEvent,
  addExchangeBet,
  getSecondaryMatchOddsByEvent,
  getCurrencyTypeFromToken,
} from '../../store';
import API from '../../api';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import { SportIdByNameMap, SportMarketMap, ThousandFormatter } from '../../util/stringUtil';
import JercyIcon from '../../assets/images/sportsbook/icons/horse-jercy.png';

type OddsInfoMsg = {
  launch: boolean;
  oddsType: string;
  eventTypeID: string;
};

type StoreProps = {
  eventData: EventDTO;
  bets: PlaceBetRequest[];
  openBets: UserBet[];
  addExchangeBet: (data: PlaceBetRequest) => void;
  selectedEventType: SelectedObj;
  secondaryMatchOdds: MatchOddsDTO[];
  isMultiMarket?: boolean;
  exposureMap: any;
  langData: any;
  fetchEvent: (
    sportId: string,
    competitionId: string,
    eventId: string,
    marketTime: string
  ) => void;
};

type Props = StoreProps & {
  loggedIn: boolean;
  getFormattedMinLimit: (num: number) => string;
  getFormattedMaxLimit: (num: number) => string;
};

type LimitsType = Map<string, { minStake: number; maxStake: number }>;

const MatchOddsTable: React.FC<Props> = (props) => {
  const {
    eventData,
    bets,
    openBets,
    addExchangeBet,
    selectedEventType,
    secondaryMatchOdds,
    loggedIn,
    isMultiMarket,
    exposureMap,
    fetchEvent,
    getFormattedMinLimit,
    getFormattedMaxLimit,
    langData,
  } = props;
  const [matchOddsData, setMatchOddsData] = useState<MatchOddsDTO>();
  const disabledStatus = ['suspended', 'closed', 'suspended-manually'];
  const [minStake, setMinStake] = useState<number>(500);
  const [maxStake, setMaxStake] = useState<number>(50000);
  const [limits, setLimits] = useState<LimitsType>();
  const [sportMarketLimits, setSportMarketLimits] = useState<LimitsType>();
  const [open, setOpen] = useState<String[]>([]);
  const [selectedRow, setSelectedRow] = useState<string>('');
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];

  const [infoDilalog, setInfoDialog] = useState<OddsInfoMsg>({
    launch: false,
    oddsType: null,
    eventTypeID: null,
  });

  const liveImagesMap = {
    '1': FootballLiveImg,
    '2': TennisLiveImg,
    '4': CricketLiveImg,
  };

  const tableFields = [
    {
      key: 'teamName',
      Label: langData?.['market'],
      className: 'market-name-cell-head',
      align: 'left',
    },
    {
      key: 'Back',
      Label: langData?.['back'],
      className: 'odds-cell-head',
      align: 'right',
    },
    {
      key: 'Lay',
      Label: langData?.['lay'],
      className: 'odds-cell-head',
      align: 'left',
    },
  ];

  // const fetchBetLimits = async () => {
  //   try {
  //     const payload = {
  //       betLimitsType: 'MARKET',
  //       minStake: null,
  //       maxStake: null,
  //       category: 'SPORTS',
  //       sportId: eventData.sportId,
  //       competitionId: eventData.competitionId,
  //       eventId: eventData.eventId,
  //       marketType: 'MATCH_ODDS',
  //       marketId: '-',
  //       sessionId: '-',
  //     };
  //     let response;
  //     if (sessionStorage.getItem('jwt_token')) {
  //       response = await API.post('/house/fetch-bet-limits', payload, {
  //         headers: {
  //           Authorization: sessionStorage.getItem('jwt_token'),
  //         },
  //       });
  //     } else {
  //       response = await API.post('/house/fetch-bet-limits', payload);
  //     }

  //     if (response.status === 200 && response.data.length !== 0) {
  //       const order = [
  //         'HOUSE',
  //         'CATEGORY',
  //         'SPORT',
  //         'COMPETITION',
  //         'EVENT',
  //         'MARKET',
  //         'SPORT_MARKET'
  //       ];
  //       const data = response.data;
  //       data.sort((a, b) => {
  //         const aDesc = a.betLimitsType;
  //         const bDesc = b.betLimitsType;
  //         if (order.indexOf(aDesc) > order.indexOf(bDesc)) {
  //           return -1;
  //         } else if (
  //           order.indexOf(aDesc) < order.indexOf(bDesc) ||
  //           order.indexOf(aDesc) === -1 ||
  //           order.indexOf(bDesc) === -1
  //         ) {
  //           return 1;
  //         } else {
  //           return -1;
  //         }
  //       });

  //       // Set gen min and max stakes
  //       const otherLimits = data.filter(
  //         (l) => l.betLimitsType !== 'MARKET' && !l.genId.includes('MATCH_ODDS')
  //       );
  //       setMinStake(otherLimits[0].minStake);
  //       setMaxStake(otherLimits[0].maxStake);

  //       const sportLimits = data.filter(
  //         (l) => l.betLimitsType === 'SPORT_MARKET' && (eventData.sportId !== '1'?l.genId.includes('MATCH_ODDS'):l)
  //       );
  //       if (sportLimits.length > 0) {
  //         const limits: LimitsType = new Map();
  //         for (let ml of sportLimits) {
  //           const genIdParts = ml.genId.split(':');

  //           limits.set(genIdParts[genIdParts.length - 1], {
  //             minStake: ml.minStake,
  //             maxStake: ml.maxStake,
  //           });
  //         }
  //         setSportMarketLimits(limits);
  //       }
  //       // Set min and max limits by market
  //       const marketLimits = data.filter(
  //         (l) => l.betLimitsType === 'MARKET' && l.genId.includes('MATCH_ODDS')
  //       );
  //       if (marketLimits.length > 0) {
  //         const limits: LimitsType = new Map();
  //         for (let ml of marketLimits) {
  //           const genIdParts = ml.genId.split(':');

  //           limits.set(genIdParts[genIdParts.length - 2], {
  //             minStake: ml.minStake,
  //             maxStake: ml.maxStake,
  //           });
  //         }
  //         setLimits(limits);
  //       }
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const getBetLimits = (market: MatchOddsDTO, limit: 'min' | 'max') => {
    const marketKey =
      eventData.sportId === '1'
        ? SportMarketMap[market?.marketName.toUpperCase()]
        : 'MTMATCH_ODDS';
    if (limits && limits.get('MI' + market?.marketId)) {
      return limit === 'min'
        ? [limits.get('MI' + market?.marketId).minStake]
        : [limits.get('MI' + market?.marketId).maxStake];
    } else if (
      marketKey &&
      sportMarketLimits &&
      sportMarketLimits.get(marketKey)
    ) {
      return limit === 'min'
        ? [sportMarketLimits.get(marketKey).minStake]
        : [sportMarketLimits.get(marketKey).maxStake];
    } else {
      return limit === 'min' ? [minStake] : [maxStake];
    }
  };

  // useEffect(() => {
  //   fetchBetLimits();
  // }, [loggedIn]);

  useEffect(() => {
    if (eventData !== null) {
      setMatchOddsData(eventData.matchOdds);
    }
  }, [eventData]);

  const getOpenBetsPL = (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO
  ) => {
    let returns = null;

    if (exposureMap && exposureMap?.[`${marketId}:${marketName}`]) {
      for (let rn of exposureMap[`${marketId}:${marketName}`]) {
        if (rn.runnerId === runner.runnerId) {
          return rn?.userRisk / cFactor;
        }
      }
    }
  };

  const getOpenBetsPLInArray = (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO
  ) => {
    let pl = getOpenBetsPL(marketId, marketName, runner);
    return pl ? [pl] : [];
  };

  const getTotalPL = (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO
  ) => {
    let returns = null;
    const mBetslipBets = bets.filter(
      (b) =>
        // (b.marketName === 'Match Odds' || b.marketName === 'Goal Markets') &&
        b.marketId === marketId && b.amount && b.amount > 0
    );

    if (mBetslipBets.length > 0) {
      returns = getOpenBetsPL(marketId, marketName, runner);
      for (let bet of mBetslipBets) {
        const plVal = bet.oddValue * bet.amount - bet.amount;
        if (bet.betType === 'BACK') {
          if (bet.outcomeId === runner.runnerId) {
            returns ? (returns += plVal) : (returns = plVal);
          } else {
            returns ? (returns -= bet.amount) : (returns = 0 - bet.amount);
          }
        } else if (bet.betType === 'LAY') {
          if (bet.outcomeId !== runner.runnerId) {
            returns ? (returns += bet.amount) : (returns = bet.amount);
          } else {
            returns ? (returns -= plVal) : (returns = 0 - plVal);
          }
        }
      }
    }
    return [returns];
  };

  return (
    <>
      <div className="matchodds-table-ctn">
        <div className="matchodds-table-content table-ctn">
          {matchOddsData?.runners?.length > 0 &&
          matchOddsData.status.toLowerCase() !== 'closed' ? (
            <TableContainer component={Paper}>
              <Table className="matchodds-table">
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={3}>
                      <div className="market-name-cell-head-ctn">
                        <span>
                          {langData?.['match_odds']}
                          <IonIcon
                            className="info-img"
                            onClick={() =>
                              setInfoDialog({
                                launch: true,
                                oddsType: 'MatchOdds',
                                eventTypeID: selectedEventType.id,
                              })
                            }
                            src={InfoImg}
                          />
                          {eventData?.status === 'IN_PLAY' ? (
                            <IonIcon
                              className="live-img"
                              color="primary"
                              src={liveImagesMap[selectedEventType.id]}
                            />
                          ) : null}
                          <IonIcon className="timer-img" src={TimerImg} />
                          <span className="delay-details">
                            {/* {eventData?.sportId === '4' ? '5S' : '7S'} */}
                            5S
                          </span>
                        </span>
                        <span className="bet-limits-section">
                          {langData?.['min']}:
                          {ThousandFormatter(
                            eventData?.matchOdds?.marketLimits
                              ? eventData?.matchOdds?.marketLimits?.minStake /
                                  cFactor
                              : 100,
                            'min'
                          )}{' '}
                          {langData?.['max']}:
                          {eventData?.matchOdds?.marketLimits?.maxStake %
                            1000 ===
                          0
                            ? ThousandFormatter(
                                eventData?.matchOdds?.marketLimits
                                  ? eventData?.matchOdds?.marketLimits
                                      ?.maxStake / cFactor
                                  : 5000,
                                'max'
                              )
                            : eventData?.matchOdds?.marketLimits
                            ? eventData?.matchOdds?.marketLimits?.maxStake /
                              cFactor
                            : 5000}
                          {/* {ThousandFormatter(
                            eventData?.matchOdds?.marketLimits
                              ? eventData?.matchOdds?.marketLimits.?.maxStake /
                              cFactor
                              : 5000
                          )} */}
                        </span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow className="header-row">
                    {tableFields.map((tF, index) => (
                      <TableCell
                        key={tF.key + index}
                        align={
                          tF.align === 'left'
                            ? 'left'
                            : tF.align === 'right'
                            ? 'right'
                            : 'center'
                        }
                        colSpan={1}
                        className={tF.className}
                      >
                        {tF.key === 'lay' || 'back' ? (
                          <div className={tF.key.toLowerCase() + '-odd'}>
                            {tF.Label}
                          </div>
                        ) : (
                          tF.Label
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                  {matchOddsData ? (
                    <>
                      {matchOddsData.runners
                        .filter(
                          (runner, idx) =>
                            runner?.status.toLowerCase() !== 'loser'
                        )
                        .map((runner, index) => (
                          <MatchOddsRow
                            minStake={
                              matchOddsData?.marketLimits
                                ? matchOddsData?.marketLimits?.minStake /
                                  cFactor
                                : 0
                            }
                            maxStake={
                              matchOddsData?.marketLimits
                                ? matchOddsData?.marketLimits?.maxStake /
                                  cFactor
                                : 0
                            }
                            eventData={eventData}
                            marketName="Match Odds"
                            // marketLimits={marketLimits}
                            matchOddsData={matchOddsData}
                            runner={runner}
                            getOpenBetsPL={getOpenBetsPLInArray}
                            getTotalPL={getTotalPL}
                            disabledStatus={disabledStatus}
                            addExchangeBet={addExchangeBet}
                            bets={bets}
                            selectedRow={selectedRow}
                            setSelectedRow={setSelectedRow}
                            open={open}
                            setOpen={setOpen}
                            index={index}
                          />
                        ))}
                    </>
                  ) : (
                    <>
                      <TableRow>
                        <TableCell colSpan={3}>
                          <div className="fm-table-msg-text">
                            {langData?.['goal_markets_not_found_txt']}
                          </div>
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          ) : null}
          {secondaryMatchOdds.map((moData, idx) => (
            <>
              {moData.status.toLowerCase() !== 'closed' ? (
                <TableContainer component={Paper}>
                  <Table className="matchodds-table">
                    <TableHead>
                      <TableRow>
                        <TableCell colSpan={3}>
                          <div className="market-name-cell-head-ctn">
                            <span>
                              {moData.marketName}{' '}
                              {/* Winner, over/under2.5 Goals */}
                              <IonIcon
                                className="info-img"
                                onClick={() =>
                                  setInfoDialog({
                                    launch: true,
                                    oddsType: 'MatchOdds',
                                    eventTypeID: selectedEventType.id,
                                  })
                                }
                                src={InfoImg}
                              />
                              <IonIcon className="timer-img" src={TimerImg} />
                              <span className="delay-details">
                                {/* {eventData?.sportId === '4' ? '5S' : '7S'} */}
                                5S
                              </span>
                            </span>
                            <span>
                              {langData?.['min']}:
                              {ThousandFormatter(
                                moData?.marketLimits
                                  ? moData?.marketLimits?.minStake / cFactor
                                  : 100,
                                'min'
                              )}{' '}
                              {langData?.['max']}:
                              {moData?.marketLimits?.maxStake % 1000 === 0
                                ? ThousandFormatter(
                                    moData?.marketLimits
                                      ? moData?.marketLimits?.maxStake / cFactor
                                      : 5000,
                                    'max'
                                  )
                                : moData?.marketLimits
                                ? moData?.marketLimits?.maxStake / cFactor
                                : 5000}
                            </span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow className="header-row">
                        {tableFields.map((tF, index) => (
                          <TableCell
                            key={tF.key + index}
                            align={
                              tF.align === 'left'
                                ? 'left'
                                : tF.align === 'right'
                                ? 'right'
                                : 'center'
                            }
                            colSpan={1}
                            className={tF.className}
                          >
                            {tF.key === 'lay' || 'back' ? (
                              <div className={tF.key.toLowerCase() + '-odd'}>
                                {tF.Label}
                              </div>
                            ) : (
                              tF.Label
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                      {moData ? (
                        <>
                          {moData.runners
                            .filter(
                              (runner, idx) =>
                                runner?.status.toLowerCase() !== 'loser'
                            )
                            .map((runner, index) => (
                              <MatchOddsRow
                                minStake={
                                  moData?.marketLimits
                                    ? moData?.marketLimits?.minStake / cFactor
                                    : 0
                                }
                                maxStake={
                                  moData?.marketLimits
                                    ? moData?.marketLimits?.maxStake / cFactor
                                    : 0
                                }
                                eventData={eventData}
                                marketName={moData?.marketName}
                                // marketLimits={marketLimits}
                                matchOddsData={moData}
                                runner={runner}
                                getOpenBetsPL={getOpenBetsPLInArray}
                                getTotalPL={getTotalPL}
                                disabledStatus={disabledStatus}
                                addExchangeBet={addExchangeBet}
                                bets={bets}
                                selectedRow={selectedRow}
                                setSelectedRow={setSelectedRow}
                              />
                            ))}
                        </>
                      ) : (
                        <>
                          <TableRow>
                            <TableCell colSpan={3}>
                              <div className="fm-table-msg-text">
                                {langData?.['no_goals_markets_txt']}
                              </div>
                            </TableCell>
                          </TableRow>
                        </>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : null}
            </>
          ))}

          <Modal
            open={infoDilalog.launch}
            closeHandler={() =>
              setInfoDialog({
                launch: false,
                oddsType: null,
                eventTypeID: null,
              })
            }
            customClass="light-bg-title"
            title={langData?.['rules']}
            size="md"
          >
            <MarketTermsCondi
              oddsType={infoDilalog.oddsType}
              eventTypeID={infoDilalog.eventTypeID}
            />
          </Modal>
        </div>
      </div>
    </>
  );
};

type MatchOddsRowProps = {
  eventData: EventDTO;
  marketName: string;
  matchOddsData: MatchOddsDTO;
  runner: MatchOddsRunnerDTO;
  getOpenBetsPL: (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO,
    type: string
  ) => number[];
  getTotalPL: (
    marketId: string,
    marketName: string,
    runner: MatchOddsRunnerDTO
  ) => number[];
  disabledStatus: string[];
  addExchangeBet: (data: PlaceBetRequest) => void;

  minStake: any;
  maxStake: any;
  // marketLimits: any;
  bets: PlaceBetRequest[];
  selectedRow: string;
  setSelectedRow: (data) => void;
  open?: String[];
  setOpen?: (data) => void;
  index?: number;
};

const MatchOddsRow: React.FC<MatchOddsRowProps> = (props) => {
  const {
    eventData,
    marketName,
    matchOddsData,
    runner,
    getOpenBetsPL,
    getTotalPL,
    disabledStatus,
    addExchangeBet,
    minStake,
    maxStake,
    bets,
    selectedRow,
    setSelectedRow,
  } = props;

  const isOddDisable = (
    eventData: EventDTO,
    status: string,
    suspend: boolean,
    betType: string,
    odd: number,
    marketTime?: Date
  ) => {
    if ((eventData.sportId == SportIdByNameMap.tennis || eventData.sportId == SportIdByNameMap.soccer) && eventData.status !== 'IN_PLAY') {
      return true;
    }
    if (disabledStatus.includes(status.toLowerCase()) || suspend === true)
      return true;

    if (matchOddsData?.marketLimits?.maxOdd < odd) return true;

    // BBL CUP
    if (matchOddsData?.marketName.toLowerCase().includes('winner'))
      return false;

    if (['77', '4339'].includes(eventData.sportId)) {
      // if (betType === 'lay') return true;

      let duration = moment.duration(
        moment(Number(marketTime) * 1000).diff(moment())
      );
      return duration.asMinutes() < 10 && duration.asMinutes() > 0
        ? false
        : true;
    }

    return moment(eventData.openDate).diff(moment(), 'seconds') < 0
      ? false
      : true;
  };

  return (
    <TableRow>
      <TableCell className="team-name-cell">
        {eventData?.sportId == '77' ? (
          <div className="horseracing-ctn">
            <div className="item1">
              <span className="list-item11">{runner.clothNumber}</span>
              <span className="list-item1">({runner.stallDraw})</span>
            </div>
            <div className="horseracing-img">
              <img
                src={runner?.runnerIcon}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = JercyIcon;
                }}
                className="runner-img"
              />
            </div>

            <div className="runner-section">
              <div className="runner-name">{runner.runnerName}</div>

              <div className="runner-desc">
                <ul className="runner-desc-list">
                  <li className="list-item">
                    <span className="label">J: </span>
                    {runner?.jockeyName ? runner?.jockeyName : '-'}
                  </li>
                  {/* <li className="list-item">
                  <span className="label">Trainer: </span>
                  {runner?.trainerName ? runner?.trainerName : '-'}
                </li> */}
                  <li className="list-item">
                    <span className="label">Age: </span>
                    {runner?.runnerAge ? runner?.runnerAge : '-'}
                  </li>
                </ul>
              </div>
            </div>
            {getOpenBetsPL(
              matchOddsData.marketId,
              matchOddsData.marketName,
              runner,
              'array'
            ).map((ret) =>
              ret !== null ? (
                <div className="profit-loss-box">
                  <span className={ret >= 0 ? 'profit' : 'loss'}>
                    {ret > 0
                      ? '+' + Number(ret).toFixed(2)
                      : Number(ret).toFixed(2)}
                  </span>
                </div>
              ) : null
            )}
          </div>
        ) : (
          <div className="team">
            {runner.runnerName}
            {getOpenBetsPL(
              matchOddsData.marketId,
              matchOddsData.marketName,
              runner,
              'array'
            ).map((ret) =>
              ret !== null ? (
                <span className={ret >= 0 ? 'profit' : 'loss'}>
                  {ret > 0
                    ? '+' + Number(ret).toFixed(2)
                    : Number(ret).toFixed(2)}
                </span>
              ) : null
            )}
          </div>
        )}
        <div>
          {getTotalPL(
            matchOddsData.marketId,
            matchOddsData.marketName,
            runner
          ).map((ret) =>
            ret !== null ? (
              <div className="profit-loss-box">
                <span className={ret >= 0 ? 'profit' : 'loss'}>
                  {ret > 0
                    ? '+' + Number(ret).toFixed(2)
                    : Number(ret).toFixed(2)}
                </span>
              </div>
            ) : null
          )}
        </div>
      </TableCell>
      <TableCell className="odds-cell">
        <div className="odds-block web-view back-odds-block">
          {runner.backPrices.length > 0 ? (
            runner.backPrices.map((odds, idx) => (
              <ExchOddBtn
                mainValue={odds?.price}
                subValue={odds.size}
                showSubValueinKformat={true}
                oddType="back-odd"
                valueType="matchOdds"
                oddsSet={[
                  runner.backPrices[0] ? runner.backPrices[0]?.price : 0,
                  runner.backPrices[1] ? runner.backPrices[1]?.price : 0,
                  runner.backPrices[2] ? runner.backPrices[2]?.price : 0,
                ]}
                key={idx}
                disable={isOddDisable(
                  eventData,
                  matchOddsData.status.toLowerCase(),
                  matchOddsData.suspend,
                  'back',
                  odds.price,
                  matchOddsData.marketTime
                )}
                // disable={
                //   disabledStatus.includes(matchOddsData.status.toLowerCase()) ||
                //   moment(eventData?.openDate).diff(moment(), 'minutes') >
                //     60 * 24 * 2 ||
                //   matchOddsData?.marketLimits?.maxOdd < odds?.price
                // }
                onClick={() => {
                  if (
                    moment(eventData?.openDate).diff(moment(), 'hour') <= 24 ||
                    eventData?.status === 'IN_PLAY' ||
                    disabledStatus.includes(
                      matchOddsData.status.toLowerCase()
                    ) ||
                    matchOddsData.suspend === true ||
                    !['77', '4339'].includes(eventData.sportId)
                  ) {
                    setSelectedRow(runner.runnerId + marketName + 'MO');
                    addExchangeBet({
                      sportId: eventData.sportId,
                      seriesId: eventData.competitionId,
                      seriesName: eventData.competitionName,
                      eventId: eventData.eventId,
                      eventName: eventData.eventName,
                      eventDate: eventData.openDate,
                      marketId: matchOddsData.marketId,
                      marketName: marketName,
                      marketType: 'MO',
                      outcomeId: runner.runnerId,
                      outcomeDesc: runner.runnerName,
                      betType: 'BACK',
                      amount: 0,
                      oddValue: odds?.price,
                      oddSize: odds.size,
                      sessionPrice: -1,
                      srEventId: eventData.eventId,
                      srSeriesId: eventData.competitionId,
                      srSportId: eventData.sportId,
                      minStake: minStake,
                      maxStake: maxStake,
                      oddLimt: matchOddsData?.marketLimits?.maxOdd.toString(),
                      mcategory: 'ALL',
                    });
                  }
                }}
              />
            ))
          ) : (
            <></>
          )}
        </div>
        <div className="odds-block mob-view">
          <ExchOddBtn
            mainValue={runner.backPrices[0]?.price}
            subValue={runner.backPrices[0]?.size}
            showSubValueinKformat={true}
            oddType="back-odd"
            valueType="matchOdds"
            disable={isOddDisable(
              eventData,
              matchOddsData.status.toLowerCase(),
              matchOddsData.suspend,
              'back',
              runner.backPrices[0]?.price,
              matchOddsData.marketTime
            )}
            onClick={() => {
              if (
                moment(eventData?.openDate).diff(moment(), 'hour') <= 24 ||
                eventData?.status === 'IN_PLAY' ||
                disabledStatus.includes(matchOddsData.status.toLowerCase()) ||
                matchOddsData.suspend === true ||
                !['77', '4339'].includes(eventData.sportId)
              ) {
                setSelectedRow(runner.runnerId + marketName + 'MO');
                addExchangeBet({
                  sportId: eventData.sportId,
                  seriesId: eventData.competitionId,
                  seriesName: eventData.competitionName,
                  eventId: eventData.eventId,
                  eventName: eventData.eventName,
                  eventDate: eventData.openDate,
                  marketId: matchOddsData.marketId,
                  marketName: marketName,
                  marketType: 'MO',
                  outcomeId: runner.runnerId,
                  outcomeDesc: runner.runnerName,
                  betType: 'BACK',
                  amount: 0,
                  oddValue: runner.backPrices[0].price,
                  oddSize: runner.backPrices[0].size,
                  sessionPrice: -1,
                  srEventId: eventData.eventId,
                  srSeriesId: eventData.competitionId,
                  srSportId: eventData.sportId,
                  minStake: minStake,
                  maxStake: maxStake,
                  oddLimt: matchOddsData?.marketLimits?.maxOdd.toString(),
                  mcategory: 'ALL',
                });
              }
            }}
          />
        </div>
      </TableCell>
      <TableCell className="odds-cell">
        <div className="odds-block web-view">
          {runner.layPrices.length > 0 ? (
            runner.layPrices.map((odds, idx) => (
              <ExchOddBtn
                mainValue={odds?.price}
                subValue={odds.size}
                showSubValueinKformat={true}
                oddType="lay-odd"
                valueType="matchOdds"
                oddsSet={[
                  runner.layPrices[0] ? runner.layPrices[0]?.price : 0,
                  runner.layPrices[1] ? runner.layPrices[1]?.price : 0,
                  runner.layPrices[2] ? runner.layPrices[2]?.price : 0,
                ]}
                key={idx}
                disable={isOddDisable(
                  eventData,
                  matchOddsData.status.toLowerCase(),
                  matchOddsData.suspend,
                  'lay',
                  odds.price
                )}
                onClick={() => {
                  if (
                    moment(eventData?.openDate).diff(moment(), 'hour') <= 24 ||
                    eventData?.status === 'IN_PLAY' ||
                    disabledStatus.includes(
                      matchOddsData.status.toLowerCase()
                    ) ||
                    matchOddsData.suspend === true ||
                    !['77', '4339'].includes(eventData.sportId)
                  ) {
                    setSelectedRow(runner.runnerId + marketName + 'MO');
                    addExchangeBet({
                      sportId: eventData.sportId,
                      seriesId: eventData.competitionId,
                      seriesName: eventData.competitionName,
                      eventId: eventData.eventId,
                      eventName: eventData.eventName,
                      eventDate: eventData.openDate,
                      marketId: matchOddsData.marketId,
                      marketName: marketName,
                      marketType: 'MO',
                      outcomeId: runner.runnerId,
                      outcomeDesc: runner.runnerName,
                      betType: 'LAY',
                      amount: 0,
                      oddValue: odds?.price,
                      oddSize: odds.size,
                      sessionPrice: -1,
                      srEventId: eventData.eventId,
                      srSeriesId: eventData.competitionId,
                      srSportId: eventData.sportId,
                      minStake: minStake,
                      maxStake: maxStake,
                      oddLimt: matchOddsData?.marketLimits?.maxOdd.toString(),
                      mcategory: 'ALL',
                    });
                  }
                }}
              />
            ))
          ) : (
            <></>
          )}
        </div>
        <div className="odds-block mob-view">
          <ExchOddBtn
            mainValue={runner.layPrices[0].price}
            subValue={runner.layPrices[0].size}
            showSubValueinKformat={true}
            oddType="lay-odd"
            valueType="matchOdds"
            disable={isOddDisable(
              eventData,
              matchOddsData?.status?.toLowerCase(),
              matchOddsData.suspend,
              'lay',
              runner?.layPrices[0]?.price
            )}
            onClick={() => {
              if (
                moment(eventData?.openDate).diff(moment(), 'minutes') <= 5 ||
                eventData.status === 'IN_PLAY'
              ) {
                addExchangeBet({
                  sportId: eventData.sportId,
                  seriesId: eventData.competitionId,
                  seriesName: eventData.competitionName,
                  eventId: eventData.eventId,
                  eventName: eventData.eventName,
                  eventDate: eventData.openDate,
                  marketId: matchOddsData.marketId,
                  marketName: marketName,
                  marketType: 'MO',
                  outcomeId: runner.runnerId,
                  outcomeDesc: runner.runnerName,
                  betType: 'LAY',
                  amount: 0,
                  oddValue: runner.layPrices[0]?.price,
                  oddSize: runner.layPrices[0]?.size,
                  sessionPrice: -1,
                  srEventId: eventData.eventId,
                  srSeriesId: eventData.competitionId,
                  srSportId: eventData.sportId,
                  minStake: minStake,
                  maxStake: maxStake,
                  oddLimt: matchOddsData?.marketLimits?.maxOdd.toString(),
                  mcategory: 'ALL',
                });
              }
            }}
          />
        </div>
      </TableCell>
    </TableRow>
  );
};

const mapStateToProps = (state: RootState) => {
  const eventType = state.exchangeSports.selectedEventType;
  const competition = state.exchangeSports.selectedCompetition;
  const event = state.exchangeSports.selectedEvent;
  return {
    // eventData: getAllMarketsByEvent(
    //   state.exchangeSports.events,
    //   eventType.id,
    //   competition.id,
    //   event.id
    // ),
    // secondaryMatchOdds: getSecondaryMatchOddsByEvent(
    //   state.exchangeSports.secondaryMatchOddsMap,
    //   event.id
    // ),
    selectedEventType: eventType,
    bets: state.exchBetslip.bets,
    openBets: state.exchBetslip.openBets,
    langData: state.common.langData,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: PlaceBetRequest) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MatchOddsTable);
